module.exports = __webpack_public_path__ + "static/2-c280d3fd021da524e3ae805964e00454.jpg";